import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type SxArrayItem =
  | boolean
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

const isSxArray = (sx: SxProps<Theme>): sx is readonly SxArrayItem[] => Array.isArray(sx);

export const toSxArray = (sx?: SxProps<Theme>): SxArrayItem[] => {
  if (!sx) {
    return [];
  }

  return isSxArray(sx) ? [...sx] : [sx];
};
